// react
import { ApolloProvider } from "@apollo/client";
// dependencies
import { Map } from "immutable";
import React from "react";
import { connect } from "react-redux";
import { ScrollRestoration } from "react-router-dom";

import { Toast } from "@performyard/py-components";
import { ClampedTextTooltipManager } from "@performyard/py-components";

import EmployeeTooltipCardWrapper from "../components/Link/Cards/Employee/EmployeeTooltipCardWrapper";
import GoalTooltipCardWrapper from "../components/Link/Cards/Goal/GoalTooltipCardWrapper";
import { NavigationProvider } from "../components/Navbar/NavigationContext";
import NavbarPortal from "../components/Navbar/index";

import AdminVerticalNavBar from "../containers/AdminVerticalNavBar";
import Analytics from "../containers/Analytics";
import AskPerformYard from "../containers/AskPerformYard";
// containers
import Body from "../containers/Body";
import BranchName from "../containers/BranchName";
import CelloLauncher from "../containers/CelloLauncher";
import EmployeeCard from "../containers/EmployeeCard";
import EmployeeSearch from "../containers/EmployeeSearch/EmployeeSearch";
import FeedbackDrawers from "../containers/FeedbackDrawers";
import HelpScoutBeacon from "../containers/HelpScoutBeacon";
import Modals from "../containers/Modals";
import { SessionManager } from "../containers/SessionManager";
import TaskRunner from "../containers/TaskRunner";

import { ReactRouterCompatibility } from "./router";

// actions
import { Initialize, MeasureApp } from "../actions/app.actions";

// selectors
import { getCompanySettingsContext } from "../selectors/settings";

// utils
import { initializeApolloClient } from "../utils/initializeApolloClient";

import PropTypes from "../lib/prop-types";

// contexts
import { CompanyFunctionsContext } from "../contexts";
import { AppSetup } from "./app-setup";
import runDelighted from "./delighted";

// styles
import "react-virtualized/styles.css";

const employeeSearch = document.getElementById("employee-search");
const employeeCard = document.getElementById("employee-card");
const branchName = document.getElementById("branch-name");
const adminVerticalNavBar = document.getElementById("admin-nav-bar");

const client = initializeApolloClient();
class Application extends React.Component {
	static propTypes = {
		init: PropTypes.func.isRequired,
		measure: PropTypes.func.isRequired,
		companySettings: PropTypes.instanceOf(Map).isRequired,
	};

	state = {
		hasMounted: false,
	};

	componentDidMount() {
		this.props.init();

		window.onresize = () => {
			this.props.measure();
		};

		runDelighted();

		this.setState({ hasMounted: true });
	}

	render() {
		const { hasMounted } = this.state;
		const { companySettings } = this.props;

		return (
			<section>
				<ApolloProvider client={client}>
					<CompanyFunctionsContext.Provider value={companySettings}>
						<ReactRouterCompatibility>
							<NavigationProvider>
								<AppSetup />
								<NavbarPortal />
								<Body />
								<Modals />
								<TaskRunner />
								<ClampedTextTooltipManager />

								<ScrollRestoration
									getKey={(location) => {
										return location.pathname;
									}}
								/>
								{hasMounted ? <Analytics /> : null}
								{employeeSearch ? <EmployeeSearch rootElementId="employee-search" /> : null}
								{employeeCard ? <EmployeeCard /> : null}
								{branchName ? <BranchName /> : null}
								{adminVerticalNavBar ? <AdminVerticalNavBar /> : null}
								<GoalTooltipCardWrapper />
								<EmployeeTooltipCardWrapper />
								<FeedbackDrawers />
								<AskPerformYard />
								<CelloLauncher />
								<HelpScoutBeacon />
								<SessionManager />
								<Toast />
							</NavigationProvider>
						</ReactRouterCompatibility>
					</CompanyFunctionsContext.Provider>
				</ApolloProvider>
			</section>
		);
	}
}

const mapStateToProps = (state) => ({
	companySettings: getCompanySettingsContext(state),
});

const mapDispatchToProps = (dispatch) => ({
	init: () => dispatch(Initialize()),
	measure: () => dispatch(MeasureApp()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Application);
